import ic_down from '../images/down_arrow.png';
import styles from '../styles/Styles';

function onSelectedItem(props, selected_pos, listener) {
  listener(selected_pos);
  props.data.ref.current.classList.toggle('dropdown_dsp_show');
}

export function getDropdown(props, listener, source) {
  /*
    required props =
      data { ref }
    props =
      outer_style, inner_style, is_active
  */
  if (props.data === undefined) { throw Error('No data supplied!'); }
  if (props.data.ref === undefined) { throw Error('Reference is not supplied!'); }
  if (props.data.data === undefined) { props.data.data = []; }
  if (props.outer_style === undefined) { props.outer_style = {}; }
  if (props.inner_style === undefined) { props.inner_style = {}; }
  if (props.is_active === undefined) { props.is_active = true; }
  if (!props.is_active) { props.inner_style.pointerEvents = 'none'; }
  if (props.listener === undefined) { props.listener = null; }

  let content = [];
  for (let i = 0; i < Object.keys(props.data.data).length; i++) {
    if (source == "list_grosir") {
      content.push(<div key={props.data.data[i].id} onClick={() => onSelectedItem(props, i, listener)} className='crs_pointer fnt_blk_a txt_12' style={m_style.content_item}>{`${props.data.data[i].desc} (${props.data.data[i].wholesaler_id})`}</div>)
    } else {
      content.push(<div key={props.data.data[i].id} onClick={() => onSelectedItem(props, i, listener)} className='crs_pointer fnt_blk_a txt_14' style={m_style.content_item}>{props.data.data[i].desc}</div>)
    }
  }
  return (
    <div id={props.id} style={{...m_style.root, ...props.outer_style}}>
      <div className='crs_pointer' onClick={() => props.data.ref.current.classList.toggle('dropdown_dsp_show')} style={{...{display : 'flex', flexDirection : 'row', alignItems : 'center', flex : 1}, ...props.inner_style}}>
        {source == "list_grosir" ? (
          <div className='fnt_blk_a txt_12' style={{flex : 1, padding : '0 10px 0 10px'}}>{`${props.data.selected.desc} (${props.data.selected.wholesaler_id || ''})`}</div>
        ) : (
          <div className='fnt_blk_a txt_14' style={{flex : 1, padding : '0 10px 0 10px'}}>{props.data.selected.desc}</div>
        )}
        <img alt='' style={{marginRight : 10, width:12, height : 12}} src={ic_down}/>
      </div>
      <div ref={props.data.ref} className='dropdown_dsp_none' style={{width : '100%', zIndex: 1, position: 'absolute', flexDirection : 'column', top : 50}}>
        <div id='asdas' style={{...styles.blk_brd_a, ...{borderRadius : 5, background : 'white', overflow : 'hidden'}}}>
          <div style={m_style.dropdown_content}>
            <div style={m_style.content}>{content}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

const m_style = {
  root : {
    position : 'relative',
    display : 'flex',
    flexDirection : 'column',
    height : 40
  },
  dropdown_content : {
    maxHeight: 200,
    overflow: 'auto'
  },
  content : {
    flex : 1,
    display : 'flex',
    flexDirection : 'column'
  },
  content_item : {
    display : 'flex',
    alignItems : 'center',
    height : 45,
    flexShrink : 0,
    padding : '0 10px 0 10px'
  }
}
